<template>
  <div class="videos">
    <div class="videos__divider" />
    <p class="videos__title">
      {{ $t("How To Earn Passively?") }}
    </p>

    <div class="videos__videoWrapper">
      <gl-video-embed
        :url="video1"
        class="videos__video"
      />

      <gl-video-embed
        :url="video2"
        class="videos__video"
      />
    </div>

    <div class="videos__btnWrapper">
      <a :href="toRegistration" target="_blank" class="videos__btn">
        {{ $t("Sign up") }}
      </a>
    </div>
  </div>
</template>

<script>
import GlVideoEmbed from "@gl/GlVideoEmbed";
import { toRegistration } from "@/tools";

export default {
  name: "Videos",
  components: {
    GlVideoEmbed,
  },
  data() {
    return {
      videos: {
        en: "PBEqe52Twro",
        de: "i0dut4uMU4g",
        ru: "gTDKXjnAQ88",
      },
    };
  },
  computed: {
    video1() {
      const videos = {
        en: 'bGryh3qTpbY',
        de: '07YKWfRNPxA',
        ru: 'AdOQKtDh61I',
        es: 'NPr7hQAFa3s',
        zh: 'ioOmfErdV5c',
      }
      return `https://youtu.be/${videos[this.$i18n.locale] || videos.en}`
    },
    video2() {
      const videos = {
        en: 'N6zgWnzEp_I',
        de: 'cgrNrb8Ag2s',
        ru: 't39HijgqUG4',
        hi: 'OyA3TIVkAlA',
        es: 'OFXn4HbnYGo',
      }
      return `https://youtu.be/${videos[this.$i18n.locale] || videos.en}`
    },
    toRegistration
  }
};
</script>

<style lang="scss" scoped>
.videos {
  padding: 0 16px 64px;

  @media (min-width: $breakpoint-xl) {
    padding: 0 100px 96px;
  }

  &__divider {
    border: solid $color-primary;
    border-width: 3px 0 0;
    width: 150px;
    margin: 0 auto;
  }

  &__title {
    font-size: 20px;
    line-height: 32px;
    text-align: center;
    font-weight: 700;
    margin-top: 64px;

    @media (min-width: $breakpoint-xl) {
      font-size: 24px;
      line-height: 48px;
      margin-top: 96px;
    }
  }

  &__tabs {
    margin-top: 48px;
    @media (min-width: $breakpoint-md) {
      margin-top: 64px;
    }
  }

  &__videoWrapper {
    margin-top: 24px;
    display: flex;
    flex-direction: column;

    @media (min-width: $breakpoint-md) {
      flex-direction: row;
      margin-top: 32px;
    }
  }

  &__video {
    width: 100%;
    margin: 0 auto;

    &:first-child {
      margin-bottom: 16px;
    }

    @media (min-width: $breakpoint-md) {
      &:first-child {
        margin-bottom: 0;
        margin-right: 16px;
      }
    }

    @media (min-width: $breakpoint-xl) {
      &:first-child {
        margin-bottom: 0;
        margin-right: 36px;
      }
    }
  }

  &__btnWrapper {
    display: flex;
    justify-content: center;
    margin-top: 48px;

    @media (min-width: $breakpoint-xl) {
      margin-top: 64px;
    }
  }

  &__btn {
    padding: 20px 0px;
    text-align: center;
    font-size: 16px;
    color: #fff;
    font-weight: 700;
    line-height: 24px;
    width: 100%;
    background-color: $color-blue-4;

    &:hover {
      background-color: #1f4776;
    }

    &:active {
      background-color: #18375b;
    }

    @media (min-width: $breakpoint-md) {
      max-width: 224px;
    }
    @media (min-width: $breakpoint-xl) {
      max-width: 268px;
    }
  }
}
</style>
